import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import {
  NotificationStep,
  TeacherNotification,
  TeacherUsageNotification
} from '../../../core/models/notification.model';

@Component({
  selector: 'app-completed-objective-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="Posttest complete — your student(s) crushed it! 🌟"
      [preambles]="[{
        text: 'Big news — your student(s) just finished the Posttest for the Objective they’ve been working toward. '
          + 'That’s a meaningful milestone in building their foundational reading skills, and it wouldn’t have happened without your support. 🎉'
      }]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Open Pre/Post report"
      ctaRoute="/reports/system/objective"
      closingText="Your students are making real progress on their foundational reading skills — and so much of that is because of you. Keep it up! 💚"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Date</th>
          <th class="th">Test</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td"><span class="date-display">{{ notification.data['displaydate'] }}</span></td>
            <td class="td"><span class="badge-green">Obj. {{ notification.data.objective}} {{ notification.data.testtype }}</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true,
})
export class CompletedObjectiveNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Open the Objective Pre/Post report',
      body: 'Select the student from the dropdown and review their Pre to Posttest growth — you’ll see exactly how far they’ve come.',
    },
    {
      title: 'Share the win — with the student and their family 🏆',
      body: 'This report is printable! Sit down with your student for a quick celebratory conference and send a copy home. Growth like this deserves to be shared.',
      variant: 'green',
    }
  ];
}
